import React from 'react';
import PropTypes from 'prop-types';
import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';

import steps from './steps';
import TooltipComponent from './TooltipComponent';
import { colors } from '../../theme/color-palette';

const LAST_INDEX = 2;

const TourGuide = ({ open, tourGuideCallback, stepIndex }) => {
	const sessionFirstTimeUser = sessionStorage.getItem('firstTimeUser');
	const show = JSON.parse(sessionFirstTimeUser) && open;

	return (
		<Joyride
			data-testid="joyride"
			run={show}
			continuous
			showProgress
			steps={steps}
			showSkipButton
			disableOverlay
			hideCloseButton
			disableScrolling
			styles={{
				options: {
					zIndex: 1301,
					arrowColor: colors.PURPLE,
				},
			}}
			stepIndex={stepIndex}
			callback={tourGuideCallback}
			tooltipComponent={TooltipComponent}
		/>
	);
};

export { ACTIONS, EVENTS, STATUS, LAST_INDEX };

TourGuide.propTypes = {
	open: PropTypes.bool,
	stepIndex: PropTypes.number,
	tourGuideCallback: PropTypes.func,
};

export default TourGuide;
